import { Component, ViewChild, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { EventItem } from '../../../interfaces/event';
import { register } from 'swiper/element/bundle';
register();

@Component({
  selector: 'app-portal-event',
  templateUrl: './portal-event.component.html',
  styleUrls: ['./portal-event.component.scss']
})
export class PortalEventComponent implements AfterViewInit {
  @ViewChild('carousel') carousel: any;
  @Input() data: any;

  constructor(private cdr: ChangeDetectorRef) { }
  
  breakpoints = {
    0: {
      slidesPerView: 'auto',
      centeredSlides: true
    },
    768: {
      slidesPerView: 2,
      centeredSlides: false,
    }
  };
  lockNext: boolean = false;
  lockPrev: boolean = true;

  ngAfterViewInit() {
    this.carousel?.nativeElement.swiper.on('slideChange', () => {
      setTimeout(() => {
        this.checkLockNavigation();
      }, 50);
    });
  }

  prevSlide() {
    this.carousel.nativeElement.swiper.slidePrev(500);
  }

  nextSlide() {
    this.carousel.nativeElement.swiper.slideNext(500);
  }

  checkLockNavigation() {
    this.lockNext = this.carousel.nativeElement.swiper.isEnd;
    this.lockPrev = this.carousel.nativeElement.swiper.isBeginning;
    this.cdr.detectChanges();
  }
}
